import { render, staticRenderFns } from "./ModalPermisos.vue?vue&type=template&id=2970deb2"
import script from "./ModalPermisos.vue?vue&type=script&lang=js"
export * from "./ModalPermisos.vue?vue&type=script&lang=js"
import style0 from "./ModalPermisos.vue?vue&type=style&index=0&id=2970deb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports